export default __webpack_public_path__ + "static/media/Conference Room 1.8d720e87.jpg";